export default "__VITE_ASSET__fF7sfapw__"